import { useMemo, useRef } from 'react';
import { Appearance, Design, PrintArea } from '@/types';
import { printTypesForDesign } from '@/model/printType/printTypesForDesign';

export function usePrintabilityMap(
  printArea: PrintArea | undefined,
  appearance: Appearance,
  designs: Design[]
) {
  const printabilityMap = useRef<Map<string, boolean>>();
  const updatePrintabilityMap = useMemo(() => {
    const map = new Map();
    printabilityMap.current = map;

    return (designs: Design[]) => {
      designs.forEach((design) => {
        if (!map.has(design.id)) {
          const isPrintable =
            Boolean(printArea) && printTypesForDesign(design, printArea, appearance).length > 0;
          map.set(design.id, isPrintable);
        }
      });
    };
  }, [printArea, appearance]);

  // useMemo because this needs to be called synchronous
  useMemo(() => updatePrintabilityMap(designs), [updatePrintabilityMap, designs]);

  return printabilityMap.current!;
}
